"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var classnames_1 = __importDefault(require("classnames"));
var PREFIX = 'LoadingDots';
var classes = {
    wrapper: "".concat(PREFIX, "-wrapper"),
    loadingDots: "".concat(PREFIX, "-loadingDots"),
};
var Root = (0, styles_1.styled)('span')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(classes.wrapper)] = {
            position: 'relative',
        },
        _b[".".concat(classes.loadingDots)] = {
            position: 'absolute',
            top: 8,
            left: 8,
            display: 'flex',
            justifyContent: 'center',
            width: '5px',
            height: '5px',
            borderRadius: '50%',
            backgroundColor: theme.palette.text.primary,
            color: theme.palette.text.primary,
            animation: '$dotElastic 1s infinite linear',
            '&::before': {
                left: -theme.spacing(1),
                animation: '$dotElasticBefore 1s infinite linear',
            },
            '&::after': {
                left: theme.spacing(1),
                animation: '$dotElasticAfter 1s infinite linear',
            },
            '&::before, &::after': {
                width: '5px',
                height: '5px',
                content: '""',
                display: 'inline-block',
                position: 'absolute',
                top: 0,
                borderRadius: '50%',
                backgroundColor: theme.palette.text.primary,
                color: theme.palette.text.primary,
            },
        },
        _b['@keyframes dotElasticBefore'] = {
            '0%': {
                transform: 'scale(1, 1)',
            },
            '25%': {
                transform: 'scale(1, 1.2)',
            },
            '50%': {
                transform: 'scale(1, 0.8)',
            },
            '75%': {
                transform: 'scale(1, 1)',
            },
            '100%': {
                transform: 'scale(1, 1)',
            },
        },
        _b['@keyframes dotElastic'] = {
            '0%': {
                transform: 'scale(1, 1)',
            },
            '25%': {
                transform: 'scale(1, 1)',
            },
            '50%': {
                transform: 'scale(1, 1.2)',
            },
            '75%': {
                transform: 'scale(1, 1)',
            },
            '100%': {
                transform: 'scale(1, 1)',
            },
        },
        _b['@keyframes dotElasticAfter'] = {
            '0%': {
                transform: 'scale(1, 1)',
            },
            '25%': {
                transform: 'scale(1, 1)',
            },
            '50%': {
                transform: 'scale(1, 0.8)',
            },
            '75%': {
                transform: 'scale(1, 1.2)',
            },
            '100%': {
                transform: 'scale(1, 1)',
            },
        },
        _b);
});
var LoadingDots = function (_a) {
    var className = _a.className;
    return ((0, jsx_runtime_1.jsx)(Root, __assign({ className: classes.wrapper }, { children: (0, jsx_runtime_1.jsx)("span", { className: (0, classnames_1.default)(classes.loadingDots, className) }) })));
};
exports.default = LoadingDots;
